var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3008 6.70973C12.3008 10.5805 7.99995 13.5911 7.99995 13.5911C7.99995 13.5911 3.6991 10.5805 3.6991 6.70973C3.6991 5.56907 4.15222 4.47513 4.95879 3.66857C5.76535 2.862 6.85929 2.40887 7.99995 2.40887C9.14061 2.40887 10.2345 2.862 11.0411 3.66857C11.8477 4.47513 12.3008 5.56907 12.3008 6.70973V6.70973Z",
    stroke: "#103045",
    strokeWidth: 0.809572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.43012C8.95012 8.43012 9.72035 7.6599 9.72035 6.70978C9.72035 5.75966 8.95012 4.98944 8 4.98944C7.04989 4.98944 6.27966 5.75966 6.27966 6.70978C6.27966 7.6599 7.04989 8.43012 8 8.43012Z",
    stroke: "#103045",
    strokeWidth: 0.809572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearLocation);
export default __webpack_public_path__ + "static/media/clearLocation.d259e0cadd6c281a1f932e0a26575828.svg";
export { ForwardRef as ReactComponent };